import { PaymentHistoryModel } from '@/types/home';
import styles from './index.module.less';
import { useTranslation } from 'next-i18next';
import { CurrencyMap } from '@/components/Plan/LangCurrencyEnum';

const BillingRecordsItem = ({ data }: { data?: PaymentHistoryModel }) => {
  const { t } = useTranslation('common');

  const currencyInfo = CurrencyMap[data.currency] || CurrencyMap['USD'];
  return (
    <div className={styles.content}>
      <div className={styles.leftInfo}>
        <img
          className={styles.icon}
          src={
            data?.type === 'Subscription'
              ? '/images/settings/ins-order-history-icon.webp'
              : '/images/settings/recent-order-history-icon.webp'
          }
          style={{ background: data?.type === 'Subscription' ? '#F1EFFF' : '#FFEACE' }}
          alt="payment_icon"
        />

        <div className={styles.infoContainer}>
          <h3 className={styles.name}>{data?.name}</h3>
          <div className={styles.orderInfo}>
            <span>{`${data?.pay_time} · ${data?.type}`}</span>
            <span>{`${t('PaymentOrderID')}:${data?.order_id}`}</span>
          </div>
        </div>
      </div>

      <div className={styles.rightInfo}>{`-${currencyInfo.symbol}${(data?.amount * data?.quantity).toFixed(2)}`}</div>
    </div>
  );
};

export default BillingRecordsItem;
